/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Tab_AllInputs */

const en_notifications_tab_all = /** @type {(inputs: Notifications_Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const pt_br2_notifications_tab_all = /** @type {(inputs: Notifications_Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Notifications_Tab_AllInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_tab_all = /** @type {((inputs?: Notifications_Tab_AllInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Tab_AllInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_tab_all(inputs)
	return pt_br2_notifications_tab_all(inputs)
});